export const isConfigValid = (config) => {
  return config && Object.values(config).every((value) => value !== undefined && value !== null);
};